import { dependencies } from '../dependencies'

export const isElementReady = (selector: string): boolean => {
  const element = document.querySelector(selector)
  return !!(element && (element as HTMLElement).offsetParent !== null)
}

export const waitForElementAndScroll = (sel: string, timeout = 5000): Promise<Element> =>
  new Promise<Element>(async (resolve, reject) => {
    const start = Date.now()
    const POLLING_INTERVAL = 50

    const attemptToFindAndScroll = async () => {
      if (Date.now() - start > timeout) {
        reject(new Error(`[Tour] Timed out waiting for element: ${sel} after ${timeout}ms`))
        return
      }

      if (isElementReady(sel)) {
        const el = document.querySelector<HTMLElement>(sel)!
        const bodyOverflow = document.body.style.overflow
        const wasHidden = bodyOverflow === 'hidden'
        if (wasHidden) {
          document.body.style.overflow = 'auto'
        }

        el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })

        setTimeout(() => {
          if (wasHidden) {
            document.body.style.overflow = 'hidden'
          }
          resolve(el)
        }, 350)
        return
      }

      const stepDependencies = dependencies[sel]
      if (stepDependencies) {
        for (const dep of stepDependencies) {
          if (!isElementReady(dep.selector)) {
            try {
              const button = document.querySelector<HTMLButtonElement>(dep.button)
              if (button && isElementReady(dep.button)) {
                button.click()
                await new Promise((r) => setTimeout(r, 150))
              }
            } catch (e) {
              /* Ignore errors during automatic opening */
            }
          }
        }
      }

      setTimeout(attemptToFindAndScroll, POLLING_INTERVAL)
    }

    await attemptToFindAndScroll()
  })

export const checkElementsReady = (selectors: string[]): Record<string, boolean> => {
  const results: Record<string, boolean> = {}
  for (const selector of selectors) {
    results[selector] = isElementReady(selector)
  }
  return results
}
